import React from "react";
import { Box, ListItemButton, Typography } from "@mui/material";
import NextLink from "next/link";
import { useRouter } from "next/router";

interface SideMenuListProps {
  path: string;
  label: string;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function SideMenuList({ path, label, onClose }: SideMenuListProps) {
  const pathname = useRouter().pathname;
  const isSelected = pathname === path;

  return (
    <ListItemButton
      component={NextLink}
      href={path}
      onClick={() => onClose(false)}
      selected={isSelected}
      sx={{
        py: 2,
        px: 3,
        borderRadius: 0,
        '&.Mui-selected': {
          backgroundColor: "rgba(99, 102, 241, 0.12)",
        },
      }}
    >
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
      </Box>
    </ListItemButton>
  );
}
